const getLocalAccessToken = () => {
  const user = JSON.parse(localStorage.getItem('user'));
  return user.auth.login.data.access_token;
};

export const requestInterceptor = (request) => {
  // Auth Token
  const token = getLocalAccessToken();
  if (token) {
    request.headers['Authorization'] = `Bearer ${token}`;
  }

  return request;
};
